import React from 'react';

const ForgotPassword = () => {

    return (
        <p>This is Forgot Password Page</p>
    )
}

export default ForgotPassword 